import { Typography } from '@mui/material';
import styled from 'styled-components';
import colors from 'styles/colors';
import sizes from 'styles/sizes';

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  max-width: 1300px;

  background: white;
  margin: 15px auto 30px;
  padding: 20px;

  box-shadow: 0px 2px 4px ${colors.secondary.deepCove}15;
  border-radius: 5px;

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
  }

`;

export const Icon = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;

  background: ${colors.primary.ice};

  svg {
    height: 32pxpx;
    width: 80px;

    @media (min-width: ${sizes.media.mediumMinWidth}px) {
      height: 36pxpx;
      width: 91px;
    }
  }

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    justify-content: center;
    align-items: flex-start;
  }

`;

export const ContentPromo = styled.div`
  display: flex;
  flex-direction: column; 
  align-items: flex-start;
  justify-content: center;
  flex-grow: 1;
  padding-top: 10px;

  background: ${colors.primary.ice};

  ${ ({ theme }) => `
    font-family: ${theme.typography.fontFamily};
  `}

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    padding-top: 0px;
    padding-left: 20px;
  }
}
`;

export const CloseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  top: 50%;
  margin-top: -10px;
  position: absolute;
  right: 15px;
  width: 15px;

  path {
    transition: stroke 0.1s cubic-bezier(0, 0, 0, 0);
  }

  svg {
    padding-bottom: 0px;
  }

  &:hover {
    path {
      stroke: ${colors.primary.ocean};
    }
  }

  @media (min-width: ${sizes.media.smallMaxWidth + 0.5}px) {
    top: 10px;
    right: 10px;
    width: 15px;
    margin-top: 0px;
  }
`;

export const ContentText = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  line-height: normal;

  ${ ({ theme }) => `
    color: ${theme.palette.common.black};
  `}

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    gap: 5px;
  }
`;

export const ContentTitle = styled.p`
  display: block;
  font-size: 18px;

  ${ ({ theme }) => `
    font-family: ${theme.typography.fontFamilyBold};
  `}

  @media (min-width: ${sizes.media.mediumMinWidth}px) {
    font-size: 20px;
  }
`;

export const ContentSubTitle = styled.p`
  display: block;
  font-size: 14px;

  @media (min-width: ${sizes.media.mediumMinWidth}px) {
    font-size: 16px;
  }
`;

export const ContentAction = styled.div`
  display: block;
  padding-top: 20px;

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    padding-top: 0px;
    margin-left: 20px;
  }

  && button {
    font-size: 14px;

    @media (min-width: ${sizes.media.smallMaxWidth}px) {
      font-size: 16px;
    }
  }
`;

export const ButtonLearnMore = styled(Typography)`
  display:block;
  text-align: center;
  letter-spacing: 0.5px;
  white-space: nowrap;

  background: #4850eb;
  border-radius: 3px;
  padding: 13px 30px;

  ${ ({ theme }) => `
    font-family: ${theme.typography.fontFamilySemiBold};
    color: ${theme.palette.common.white};
  `}

  @media (min-width: ${sizes.media.smallMaxWidth}px) {
    font-size: 16px;
    border-radius: 5px;
  }
`;
